import type { CardProps } from 'src/notifications/cardTypes';
import { formatShortDate, formatTime } from 'src/utils/dateFormatting';
import NotificationCardShell from '../NotificationCardShell';
import NotificationDetailRow from '../NotificationDetailRow';
import NotificationLinkButton from '../NotificationLinkButton';

export default function MeetingWithoutAgendaCard({
  notification,
  payload,
  onClose,
}: CardProps<'MEETING_WITHOUT_AGENDA'>) {
  const destination = payload.client_id
    ? `/client/${payload.client_id}/meetings/upcoming/${payload.calendar_event_id}?generate_agenda=true`
    : `/meetings/${payload.calendar_event_id}`;

  return (
    <NotificationCardShell
      notification={notification}
      title="Meeting agenda due"
      body="An upcoming meeting has no agenda."
      clientId={payload.client_id ?? undefined}
      details={
        <>
          {payload.meeting_title && (
            <NotificationDetailRow label="Meeting" value={payload.meeting_title} />
          )}
          <NotificationDetailRow label="Date" value={formatShortDate(payload.meeting_date)} />
          <NotificationDetailRow
            label="Time"
            value={`${formatTime(payload.meeting_date)} to ${formatTime(payload.meeting_end)}`}
          />
        </>
      }
      actions={
        <NotificationLinkButton primary to={destination} onClose={onClose}>
          Generate
        </NotificationLinkButton>
      }
    />
  );
}
